export enum STUDIO_PERMISSION_ROLES {
    USER,
    MANAGER,
    OWNER
}
